<template>
  <div class="add_new_key">
    <div class="main_wrapper">
      <div>
        <div class="title">
          <i class="icon-license"></i>
          {{ $t('dashboard.generateKey') }}
        </div>
        <small>{{ $t('dashboard.generateKeyLimit') }}</small>
      </div>
      <div>
        <button type="primary" @click="addNewKey()" :loading="loading" class="btn">
          {{lang === 'en' ? "Generate" : "生成密钥" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { Message } from 'element-ui'

  export default {
    name: 'AddNewKey',
    props: {},
    data() {
      return {
        loading: false
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    methods: {
      addNewKey: async function() {
        try {
          // start loading..
          this.loading = true
          // bind the package name with the user's license key
          const response = await axios.patch(`/api/user/add-key`)
          // fetch the latest data for "license" component
          const response2 = await axios.get('/api/product/bind-app')
          // show the successful message
          Message({
            type: 'success',
            message: response.data.message,
            showClose: true
          })
          // emit the data to "license" component
          this.$root.$emit('updateKeys', response2.data.data)
          // stop loading..
          this.loading = false
        } catch (err) {
          const errorMessage =
            err.response.data.message === 'The conditional request failed'
              ? 'Reached the limit to add license keys. Please contact us if you need more keys.'
              : err.response.data.statusCode + ' ' + err.response.data.message
          // show the error message
          Message({
            type: 'error',
            message: errorMessage,
            showClose: true
          })
          console.error({ err })
          // stop loading..
          this.loading = false
        }
      }
    },
    mounted() {}
  }
</script>

<style lang="scss" scoped>
  .add_new_key {
    height: 100%;
    background: $white;
    @include border-radius(8px);
    padding: 24px 24px;
    font-size: 18px;
    position: relative;
    box-sizing: border-box;
    margin-bottom: 13px;
    border: $border;
    box-shadow: 1px 2px 4px hsla(210, 29%, 24%, 0.5);
  }
  .main_wrapper {
    display: flex;
    justify-content: space-between;
  }
  .title {
    font-family: NexaBold;
    .icon-license {
      font-size: 16px;
    }
  }
  .btn {
    padding: 8px 16px;
    border-radius: 4px;
    border: 1px solid #409eff;
    background-color: #409eff;
    color: white;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
  }
  small {
    font-size: 11px;
    font-style: italic;
    color: #777;
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/AddNewKey.vue